
(function(window, document) {
    'use strict';

    var timeline_btn = document.getElementById('js-timeline');

    if(timeline_btn) {
        timeline_btn.addEventListener("click", (event) => {
            var timeline = document.getElementById('timeline');
            timeline.classList.toggle('timeline--hidden');
            timeline_btn.classList.toggle('button__arrow--up');
        });
    }

})(window, document);
